import withNavigationTheme from '../../hooks/withNavigationTheme';
import TopNavigationBottomHeaderTabs from './TopNavigationBottomHeaderTabs';

export default withNavigationTheme(TopNavigationBottomHeaderTabs);
